/// <amd-module name="RMWidgets/DeploymentStatusWidget/DSWConstants" />
export namespace DSWColumnKeys {
    export const Environments: string = "Environments";
    export const LastDeployed: string = "LastDeployed";
    export const FailingSince: string = "FailingSince";
}

// Duplicate of Artifact.ts in release-landing. Adding here to avoid pulling from release-landing, which is a large bundle.
export namespace ArtifactDefinitionConstants {
    export const ProjectId = "project";
    export const Version = "version";
    export const ArtifactSourceVersionUrl = "artifactSourceVersionUrl";
    export const IsMultiDefinitionType = "IsMultiDefinitionType";
    export const Definition = "definition";
    export const Branch = "branch"
}

export namespace WellKnownRepositoryTypes {
    export const TfsVersionControl = "TfsVersionControl";
    export const TfsGit = "TfsGit";
    export const Git = "Git";
    export const GitHub = "GitHub";
    export const GitHubEnterprise = "GitHubEnterprise";
    export const Bitbucket = "Bitbucket";
    export const Svn = "Svn";
}

export const BranchNamePrefix: string = "refs/heads/";
